"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let PaymentOptionsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.operating = "";
    this.account_coins = new AccountCoinModel();
  }
};
PaymentOptionsModel.model = "account_coins.get_account_coins";
PaymentOptionsModel = __decorateClass([
  Annotation.ModelMeta
], PaymentOptionsModel);
export let AccountCoinModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.coins = 0;
  }
};
AccountCoinModel.model = "account_coins";
AccountCoinModel = __decorateClass([
  Annotation.ModelMeta
], AccountCoinModel);
export let PaymentCanculateModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    // 鲸豆数
    this.coin_left = 0;
    // 应付金额
    this.cost = 0;
    // 是否使用优惠券
    this.discount_coupon_used = null;
    // 最大支付鲸豆(应付金额转换汇率)
    this.max_coin = 0;
    // 折扣码报错
    this.msg = null;
    // 原价
    this.original_cost = 0;
    // VD卡是否使用
    this.vdcard_used = null;
    // 汇率兑换信息
    this.desc = null;
    // 计算支付币种
    this.currency = "CNY";
  }
};
PaymentCanculateModel.model = "payment.virtualdesktop.calculate.new.calc_result";
PaymentCanculateModel = __decorateClass([
  Annotation.ModelMeta
], PaymentCanculateModel);
export class PaymentCanculateProModel extends CoreModel {
  constructor() {
    super(...arguments);
    // 原价
    this.originalPrice = 0;
    // 折后价
    this.discountPrice = 0;
    // 鲸豆数
    this.coin = 0;
    // 应付金额
    this.payPrice = 0;
    // 报错信息
    this.errorMessage = null;
    // 优惠信息
    this.discountCoupon = new DiscountCouponModel();
    // 最大支付鲸豆(应付金额转换汇率)
    this.maxCoin = 0;
    // 汇率兑换信息
    this.desc = null;
    // 计算支付币种
    this.currency = "CNY";
  }
}
export class DiscountCouponModel extends CoreModel {
  constructor() {
    super(...arguments);
    this.couponGuid = "";
    this.type = "";
    this.name = "";
  }
}
export let PaymentCouponModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.can_not_use_reason = null;
    this.can_use = false;
    this.coupon_data = new PaymentDiscountCouponModel();
    this.good_specs = [];
    this.guid = "";
    this.is_using = false;
    this.name = "";
    this.regions = [];
    this.scenes = [];
    this.style = "";
    this.type = "";
    this.use_limit_desc = "";
    this.valid_date = new PaymentValidDateModel();
  }
};
PaymentCouponModel.model = "payment.virtualdesktop.discount_coupon_options.creatediscount_coupon";
PaymentCouponModel = __decorateClass([
  Annotation.ModelMeta
], PaymentCouponModel);
export let PaymentDiscountCouponModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.fixed_money = 0;
    this.type = "fixed";
  }
};
PaymentDiscountCouponModel.model = "discount_coupon.fixed";
PaymentDiscountCouponModel = __decorateClass([
  Annotation.ModelMeta
], PaymentDiscountCouponModel);
export let PaymentGoodSpecsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.guid = "";
    this.name = "";
  }
};
PaymentGoodSpecsModel.model = "good_spec.guid.model";
PaymentGoodSpecsModel = __decorateClass([
  Annotation.ModelMeta
], PaymentGoodSpecsModel);
export let PaymentRegionsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.guid = "";
    this.name = "";
  }
};
PaymentRegionsModel.model = "good_region.guid.model";
PaymentRegionsModel = __decorateClass([
  Annotation.ModelMeta
], PaymentRegionsModel);
export let PaymentScenesModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.code = "";
    this.name = "";
  }
};
PaymentScenesModel.model = "coupon_scenes.model";
PaymentScenesModel = __decorateClass([
  Annotation.ModelMeta
], PaymentScenesModel);
export let PaymentValidDateModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.start = 0;
    this.end = 0;
  }
};
PaymentValidDateModel.model = "coupon.valid.date";
PaymentValidDateModel = __decorateClass([
  Annotation.ModelMeta
], PaymentValidDateModel);
